<template>
    <div>        
        <router-view></router-view>        
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .top-nav{
       padding:10px 50px;
       border-bottom:2px solid #f1f1f1;
       overflow: hidden;
       a.icon{
         float:left;
       }
    }
</style>
<script>
export default {    
    methods:{
        go () {
            this.$router.go(-1)
        }
    }
}
</script>